import { render, staticRenderFns } from "./header-avatar.vue?vue&type=template&id=4e94376e&scoped=true&"
import script from "./header-avatar.vue?vue&type=script&lang=js&"
export * from "./header-avatar.vue?vue&type=script&lang=js&"
import style0 from "./header-avatar.vue?vue&type=style&index=0&id=4e94376e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e94376e",
  null
  
)

export default component.exports